var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 1C13.214 1 14.3333 2.11929 14.3333 3.5V4H20.3333V10H20.8333C22.214 10 23.3333 11.1193 23.3333 12.5C23.3333 13.8807 22.214 15 20.8333 15H20.3333V21H14.5335C14.5335 20.1667 14.2704 19.4583 13.7454 18.875C13.2205 18.2918 12.5832 18 11.8333 18C11.0834 18 10.4462 18.2918 9.9212 18.875C9.3962 19.4583 9.13312 20.1667 9.13312 21H3.33331V15.2002C4.13321 15.2002 4.83297 14.9457 5.43292 14.4375C6.03292 13.9292 6.33331 13.2833 6.33331 12.5C6.33331 11.7167 6.03292 11.0708 5.43292 10.5625C4.83297 10.0543 4.13321 9.7998 3.33331 9.7998V4H9.33331V3.5C9.33331 2.11929 10.4526 1 11.8333 1Z",
    fill: "#48CCCD"
  })));
};
export default SvgPuzzle;